

exports.__esModule = true;
exports.$SubscriptionModel = exports.$CreateBAModel = undefined;

var _squid = require('squid');

var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt',
        postAttempts: 3
    })
});

var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
    api: new _squid.$Api({
        uri: '/api/billagmt/:id',
        postAttempts: 3,
        cache: true
    })
});

angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/subscription/index.js
// module id = ./components/xo-models/src/subscription/index.js
// module chunks = 1